import { Component, Input, OnInit, ViewChildren } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Degree } from '@ascschool/model/category/degree.model';
import { WardService } from '@ascschool/services/category/ward.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DepartmentOfEducationAndTrainingService } from '@ascschool/services/organization/department-of-educatio-and-training.service';
import { CapTrucThuocService } from '@ascschool/services/category/cap-truc-thuoc.service';
import { SchoolLevelService } from '@ascschool/services/school/school-level.service';
import { ModulesService } from '@ascschool/services/category/modules.service';
import { TypeOfSchoolService } from '@ascschool/services/category/typeofschool.service';
import { EnsureConditionService } from '@ascschool/services/category/ensure-condition.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { AreaService } from '@ascschool/services/category/area.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { ModesOfEducationService } from '@ascschool/services/category/modese-of-education.service';
import { StudyModeService } from '@ascschool/services/category/study-mode.service';
import { CaDisInfrastructuresService } from '@ascschool/services/category/caDisInfrastructures.service';
import { CaFacilitiesAndEquipmentsService } from '@ascschool/services/category/caFacilitiesAndEquipments.service';
import { INzMessageType } from '@ascschool/interface/setting';

@Component({
  selector: 'app-pop-up-co-so',
  templateUrl: './pop-up-co-so.component.html',
  styleUrls: ['./pop-up-co-so.component.scss']
})
export class PopUpCoSoComponent implements OnInit {
  listInfrastructures = [];
  listFacilitiesAndEquipments = [];
  @Input() dataTransmission: any;
  @ViewChildren("label") labelElement;
  infoSoForm = new FormGroup({
    id: new FormControl(0),
    idUser: new FormControl(null),
    educationAndTrainingCode: new FormControl(''),
    educationAndTrainingName: new FormControl('', Validators.required),
    director: new FormControl(''),
    directorPhoneNumber: new FormControl(''),
    directorEmail: new FormControl(''),
    phoneNumber: new FormControl(''),
    fax: new FormControl(''),
    email: new FormControl(''),
    website: new FormControl(''),
    provinceId: new FormControl(null, Validators.required),
    districtId: new FormControl(null, Validators.required),
    wardId: new FormControl(null),
    directlyUnderId: new FormControl(null, Validators.required),
    villageName: new FormControl(''),
    address: new FormControl(''),
    typeOfEducationId: new FormControl(null),
    numberSupport: new FormControl(null),
    numberRoomForDisabled: new FormControl(null),
    numberClassroomInterventions: new FormControl(null),
    isActive: new FormControl(true),
    username: new FormControl('', Validators.required),
    schoolLevel: new FormControl([], Validators.required),
    schoolSubordinateType: new FormControl([]),
    eatProvinceCode: new FormControl(null),
    eatMinistryCode: new FormControl(null),
    educationAndTrainingType: new FormControl(null),
    organizationId: new FormControl(null),
    modesOfEducationId: new FormControl(null, Validators.required),
    moduleId: new FormControl(null, Validators.required),
    studyModeId: new FormControl(null, Validators.required),
    listDisInfrastructure: new FormArray([]),
    listFacilitiesAndEquipment: new FormArray([]),
  });
  listDisInfrastructure = this.infoSoForm.get('listDisInfrastructure') as FormArray;
  listFacilitiesAndEquipment = this.infoSoForm.get('listFacilitiesAndEquipment') as FormArray;
  currentUser: any;
  isEditMode = false;
  degreeItem = new Degree();
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup;
  disabled: boolean = false;
  provinceControl = this.infoSoForm.controls.provinceId;
  districtControl = this.infoSoForm.controls.districtId;
  wardControl = this.infoSoForm.controls.wardId;
  typeofeducationControl = this.infoSoForm.controls.typeOfEducationId;
  modulesControl = this.infoSoForm.controls.moduleId;
  numberSupportControl = this.infoSoForm.controls.numberSupport;
  directlyUnderControl = this.infoSoForm.controls.directlyUnderId;
  schoollevelControl = this.infoSoForm.controls.schoolLevel;
  subordinatetypeControl = this.infoSoForm.controls.schoolSubordinateType;
  areaControl = this.infoSoForm.controls.areaId;
  ModesOfEducationControl = this.infoSoForm.controls.modesOfEducationId;
  disStudyModeControl = this.infoSoForm.controls.studyModeId;
  listSchoolLevel: ({
    id: number;
    schoolLevelName: string;
    checked: boolean;
  })[] = [];
  listSchoolLevelSelect: number[] = [];
  listensureCondition: ({
    id: number;
    name: string;
    checked: boolean;
  })[] = [];
  listensureConditionSelect: number[] = [];


  listtypeofeducation: ({
    id: number;
    name: string;
    checked: boolean;
  })[] = [];
  listtypeofeducationSelect: number[] = [];
  listSo: ({
    id: number;
    educationAndTrainingName: string;
    checked: boolean;
  })[] = [];
  listSubordinateTypeSelect: number[] = [];
  requiredPhanHe = false;
  requiredSoPhonghoTro = false;
  requiredCapTrucThuoc = false;
  codeInfrastructures = [];
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    public utilsService: UtilsService,
    private directlyUnderService: CapTrucThuocService,
    private schoollevelService: SchoolLevelService,
    private modulesService: ModulesService,
    private typeofschoolService: TypeOfSchoolService,
    private ensureConditionService: EnsureConditionService,
    private service: SchoolService,
    private wardService: WardService,
    private areaService: AreaService,
    private provinceService: ProvinceService,
    private districtService: DistrictService,
    private soGDService: DepartmentOfEducationAndTrainingService,
    private modesOfEducationService: ModesOfEducationService,
    private disStudyModeService: StudyModeService,
    private caDisInfrastructuresService: CaDisInfrastructuresService,
    private caFacilitiesAndEquipmentsService: CaFacilitiesAndEquipmentsService,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
  }
  ngOnInit() {
    this.loadProvince();
    this.loadTypeofEducation();
    this.loadSo();
    this.loadSchoolLevel();
    this.loadDirectlyUnder();
    this.loadDisStudyMode();
    this.loadModesOfEducation();
    // this.loadModules();
    if (this.dataTransmission > 0 && this.currentUser.accountType !== 3) {
      let controls = this.infoSoForm.controls;
      this.service.getById(this.dataTransmission).subscribe(res => {
        for (const name in controls) {
          if (!this.infoSoForm.get(name)['controls']) {
            controls[name].setValue(res[name]);
          }
        }
        let listDisInfrastructures;
        listDisInfrastructures = res.listDisInfrastructure.filter(q => q.amount > 0);
        this.getInfrastructures(listDisInfrastructures);
        this.getFacilitiesAndEquipment(res.listFacilitiesAndEquipment);
        if (res.provinceId) {
          this.provinceService.getSelectPagingProvinceById(res.provinceId).subscribe(response => {
            this.provinceControl.setValue({ id: response.id, text: response.provinceName });
            this.loadDistrict();
            if (res.districtId) {
              this.districtService.getSelectPagingDistrictById(res.districtId).subscribe(re => {
                this.districtControl.setValue({ id: re.id, text: re.districtName });
                this.loadWard();
                if (res.wardId) {
                  this.wardService.getSelectPagingWardById(res.wardId).subscribe(resp => {
                    this.wardControl.setValue({ id: resp.id, text: resp.wardName });
                  });
                }
              });
            }
          });
        }
        if (res.modesOfEducationId) {
          this.modesOfEducationService.getSelectById(res.modesOfEducationId).subscribe(response => {
            this.ModesOfEducationControl.setValue({ id: response.id, text: response.name });
            this.loadModules();
            if (res.moduleId) {
              this.modulesService.getSelectPagingById(res.moduleId).subscribe(response => {
                this.modulesControl.setValue({ id: response.id, text: response.name });
              });
            }
          });
        }

        if (res.directlyUnderId) {
          this.directlyUnderService.getSelectPagingCapTrucThuocById(res.directlyUnderId).subscribe(res => {
            this.directlyUnderControl.setValue({ id: res.id, text: res.name });
          });
        }
        if (res.studyModeId) {
          this.disStudyModeService.getSelectById(res.studyModeId).subscribe(response => {
            this.disStudyModeControl.setValue({ id: response.id, text: response.name });
          });
        }
        if (res.areaId) {
          this.areaService.getSelectAreaById(res.areaId).subscribe(response => {
            this.areaControl.setValue({ id: response.id, text: response.areaName });
          });
        }
        if (res.typeOfEducationId) {
          this.typeofschoolService.getSelectPagingById(res.typeOfEducationId).subscribe(resp => {
            this.typeofeducationControl.setValue({ id: resp.id, text: resp.typeOfSchoolName, isDirectlyUnderId: resp.isDirectlyUnderId, isModule: resp.isModule, isNumberSupport: resp.isNumberSupport });
            this.changeTypeofEducation(this.typeofeducationControl, false);
          });
        }
        if (res.schoolLevel.length > 0) {
          this.listSchoolLevelSelect = res.schoolLevel;
        }
        if (res.schoolSubordinateType.length > 0) {
          this.listSubordinateTypeSelect = res.schoolSubordinateType;

        }
      });
    }

    if (this.dataTransmission > 0 && this.currentUser.accountType == 3) {
      let controls = this.infoSoForm.controls;
      this.service.GetSelectPagingById(this.dataTransmission).subscribe(res => {
        for (const name in controls) {
          if (!this.infoSoForm.get(name)['controls']) {
            controls[name].setValue(res[name]);
          }
        }
        this.getInfrastructures(res.listDisInfrastructure);
        this.getFacilitiesAndEquipment(res.listFacilitiesAndEquipment);
        if (res.provinceId) {
          this.provinceService.getSelectPagingProvinceById(res.provinceId).subscribe(response => {
            this.provinceControl.setValue({ id: response.id, text: response.provinceName });
            this.loadDistrict();
            if (res.districtId) {
              this.districtService.getSelectPagingDistrictById(res.districtId).subscribe(re => {
                this.districtControl.setValue({ id: re.id, text: re.districtName });
                this.loadWard();
                if (res.wardId) {
                  this.wardService.getSelectPagingWardById(res.wardId).subscribe(resp => {
                    this.wardControl.setValue({ id: resp.id, text: resp.wardName });
                  });
                }
              });
            }
          });
        }
        if (res.areaId) {
          this.areaService.getSelectAreaById(res.areaId).subscribe(response => {
            this.areaControl.setValue({ id: response.id, text: response.areaName });
          });
        }
        if (res.directlyUnderId) {
          this.directlyUnderService.getSelectPagingCapTrucThuocById(res.directlyUnderId).subscribe(res => {
            this.directlyUnderControl.setValue({ id: res.id, text: res.name });
          });
        }
        if (res.typeOfEducationId) {
          this.typeofschoolService.getSelectPagingById(res.typeOfEducationId).subscribe(resp => {
            this.typeofeducationControl.setValue({ id: resp.id, text: resp.typeOfSchoolName, isDirectlyUnderId: resp.isDirectlyUnderId, isModule: resp.isModule, isNumberSupport: resp.isNumberSupport });
            this.changeTypeofEducation(this.typeofeducationControl, false);
            this.loadModules();
            if (res.moduleId) {
              this.modulesService.getSelectPagingById(res.moduleId).subscribe(response => {
                this.modulesControl.setValue({ id: response.id, text: response.modulesName })
              })
            }
          });
        }
        if (res.modesOfEducationId) {
          this.modesOfEducationService.getSelectById(res.modesOfEducationId).subscribe(response => {
            this.ModesOfEducationControl.setValue({ id: response.id, text: response.name });
            this.loadModules();
            if (res.moduleId) {
              this.modulesService.getSelectPagingById(res.moduleId).subscribe(response => {
                this.modulesControl.setValue({ id: response.id, text: response.modulesName })
              })
            }
          });
        }
        if (res.studyModeId) {
          this.disStudyModeService.getSelectById(res.studyModeId).subscribe(response => {
            this.disStudyModeControl.setValue({ id: response.id, text: response.name });
          });
        }
        if (res.schoolLevel.length > 0) {
          this.listSchoolLevelSelect = res.schoolLevel;
        }
        if (res.schoolSubordinateType.length > 0) {
          this.listSubordinateTypeSelect = res.schoolSubordinateType;
        }
        this.listensureConditionSelect = res.ensureCondition;
      });
    }
  }

  close() {
    this.destroyModal();
  }

  destroyModal(): void {
    this.modal.destroy(true);
  }

  UpdateClose() {
    // if (this.currentUser.accountType == 5 || this.currentUser.accountType == 6
    //   || this.currentUser.accountType == 1 || this.currentUser.accountType == 2) {
      this.infoSoForm.controls['schoolLevel'].setValue(this.listSchoolLevelSelect);
      this.infoSoForm.controls['schoolSubordinateType'].setValue(this.listSubordinateTypeSelect);
    if(this.listFacilitiesAndEquipment.valid){
        if (this.infoSoForm.valid) {
          this.service.addOrUpdate(this.bindOfDataId(this.infoSoForm)).subscribe(res => {
            if (res.statusCode == 0) {
              if (this.infoSoForm.value.id) {
                // this.UpdateAllList();
              }
              this.utilsService.notifyResponse(res);
              this.close();
            } else {
              this.utilsService.notifyResponse(res);
            }
          });
        } else {
          this.utilsService.showNotifyInvalidControls(this.infoSoForm, this.labelElement);
        }
    }else{
        this.utilsService.showNotification(INzMessageType.Error,'Vui lòng nhập Thông tin cơ sở vật chất và phương tiện',3000);
    }
    // } else {
    //   this.msg.warning('Bạn không có quyền khởi tạo Sở');
    // }
  }

  clearForm() {
    this.infoSoForm.reset();
    this.provinceControl.setValue(null);
    this.districtControl.setValue(null);
    this.wardControl.setValue(null);
    this.typeofeducationControl.setValue(null);
    this.areaControl.setValue(null);
  }
  getProvinceACFn: (value: any) => Observable<any>;
  getTypeofEducationACFn: (value: any) => Observable<any>;
  getModulesACFn: (value: any) => Observable<any>;
  getDirectlyUnderACFn: (value: any) => Observable<any>;
  getTypeofschoolACFn: (value: any) => Observable<any>;
  getEnsureConditionACFn: (value: any) => Observable<any>;
  getDistrictACFn: (value: any) => Observable<any>;
  getWardACFn: (value: any) => Observable<any>;
  getVillageACFn: (value: any) => Observable<any>;
  getSubordinatetypeACFn: (value: any) => Observable<any>;
  getSchoolLevelACFn: (value: any) => Observable<any>;
  getAreaACFn: (value: any) => Observable<any>;
  getorganizesACFn: (value: any) => Observable<any>;
  getModesOfEducationACFn: (value: any) => Observable<any>;
  getDisStudyModeACFn: (value: any) => Observable<any>;

  loadTypeofEducation(reset = true) {
    this.getTypeofEducationACFn = (value: any) => this.typeofschoolService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.typeOfSchoolName, isDirectlyUnderId: x.isDirectlyUnderId, isModule: x.isModule, isNumberSupport: x.isNumberSupport }))
      : [{ id: null, text: 'Không có dữ liệu' }]));
    if (reset) this.typeofeducationControl.setValue(null);
  }

  changeTypeofEducation(control: AbstractControl, isSetValueNull: boolean = true) {
    this.typeofeducationControl = control;
  }

  loadModules(reset = true) {
    this.getModulesACFn = (value: any) => this.modulesService.getSelectPaging({
      searchTerm: value, TypeOfEducationId: this.valueIfHas(this.ModesOfEducationControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.modulesName, typeOfEducationId: x.typeOfEducationId }))
      : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (reset) this.modulesControl.setValue(null);
  }

  changeModules(control: FormControl) {
    this.modulesControl = control;
  }

  loadDirectlyUnder(reset = true) {
    this.getDirectlyUnderACFn = (value: any) => this.directlyUnderService.getCapTrucThuocSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.name }))
      : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (reset) this.directlyUnderControl.setValue(null);
  }

  changeDirectlyUnder(control: FormControl) {
    if (control) {
      this.directlyUnderControl = control;
    }
  }

  loadProvince(reset = true) {
    this.getProvinceACFn = (value: any) => this.provinceService.getProvinceSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.provinceName }))
      : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (reset) this.provinceControl.setValue(null);
  }

  changeProvince(control: FormControl) {
    this.provinceControl = control;
    this.loadDistrict();
    this.districtControl.setValue(null);
    this.wardControl.setValue(null);
  }

  loadDistrict(reset = true) {
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
      searchTerm: value, ProvinceId: this.valueIfHas(this.provinceControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.districtName }))
      : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (reset) this.districtControl.setValue(null);
  }

  changeDistrict(control: FormControl) {
    this.districtControl = control;
    this.loadWard();
    this.wardControl.setValue(null);
  }

  loadWard(reset = true) {
    this.getWardACFn = (value: any) => this.wardService.getWardSelectPaging({
      searchTerm: value, DistrictId: this.valueIfHas(this.districtControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.wardName }))
      : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (reset) this.wardControl.setValue(null);
  }

  changeWard(control: FormControl) {
    this.wardControl = control;
  }

  valueIfHas(control: AbstractControl) {
    if (control.value && typeof control.value != 'string') return control.value.id;
    return '';
  }

  bindOfDataId(formGroup: FormGroup) {
    let data;
    data = formGroup.value;
    const controls = formGroup.controls;
    for (const name in controls) {
      if (data[name] && data[name].id) {
        data[name] = data[name].id
      }
    }
    return data;
  }

  addEnsureCondition(id: number) {
    // them vao list điều kiện tham gia giáo dục người khuyết tật
    let index = this.listensureConditionSelect.findIndex(x => x == id);
    if (index != -1) {
      this.listensureConditionSelect.splice(index, 1);
    } else {
      this.listensureConditionSelect.push(id);
    }
  }

  addSchoolLevel(id: number) {
    // them vao list CapHoc
    let index = this.listSchoolLevelSelect.findIndex(x => x == id);
    if (index != -1) {
      this.listSchoolLevelSelect.splice(index, 1);
    } else {
      this.listSchoolLevelSelect.push(id);
    }
  }

  loadTypeofeducation() {
    this.typeofschoolService.getSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      this.listtypeofeducation = res.results.map(x => ({ id: x.id, parentName: x.parentName, typeOfEducationName: x.typeOfSchoolName, checked: false }));
    });
  }

  loadEnsureCondition() {
    this.ensureConditionService.getEnsureConditionSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      this.listensureCondition = res.results.map(x => ({ id: x.id, name: x.name, checked: false }));
    });
  }

  loadSchoolLevel() {
    this.schoollevelService.getSchoolLevelsSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      this.listSchoolLevel = res.results.map(x => ({ id: x.id, schoolLevelName: x.schoolLevelName, checked: false }));
    });
  }

  loadSo() {
    this.soGDService.GetSelectPagingBySub({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      this.listSo = res.results.map(x => ({ id: x.id, educationAndTrainingName: x.educationAndTrainingName, checked: false }));
    });
  }

  loadDisStudyMode() {
    // tslint:disable-next-line: max-line-length
    this.getDisStudyModeACFn = (value: any) =>
      this.disStudyModeService.getSelectPaging({
        searchTerm: value, PageIndex: 1, PageSize: 100
      }).pipe(map((resp) =>
        resp.results.length > 0
          ? resp.results.map((x) => ({ id: x.id, text: x.name }))
          : [{ id: null, text: 'Không có dữ liệu' }]
      ));
  }

  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisStudyMode(control: FormControl) {
    this.disStudyModeControl = control;
  }

  loadModesOfEducation(reset = true) {
    this.getModesOfEducationACFn = (value: any) => this.modesOfEducationService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.name,code : x.code }))
      : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (reset) this.wardControl.setValue(null);
  }

  changeModesOfEducation(control: FormControl) {
    this.loadModules();
    this.modulesControl.setValue(null);
    this.ModesOfEducationControl = control;
    if (this.ModesOfEducationControl.value.code === '01') {
      this.codeInfrastructures = this.listInfrastructuresOrigin.filter(x => x.code != '01');
    } else {
      this.codeInfrastructures = this.listInfrastructuresOrigin.filter(x => x.code != '02' && x.code != '03' && x.code != '04');
    }

    this.listDisInfrastructure.clear();
    this.codeInfrastructures.forEach(q=>{
      this.listDisInfrastructure.push(
        new FormGroup({
          id: new FormControl(0),
          disEducationAndTrainingOrSchoolId: new FormControl(this.dataTransmission),
          infrastructureId: new FormControl(q.id),
          amount: new FormControl(null,Validators.required),
        }),
      );
    });
  }
  listInfrastructuresOrigin = [];
  //Cơ sở hạ tầng
  getInfrastructures(value) {
    this.caDisInfrastructuresService.getSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      if (value.length > 0 && value != null) {
        this.listInfrastructuresOrigin = res.results.map(x => ({ id: x.id, name: x.name, checked: false, code:x.code }));
        value.forEach(element => {
          res.results.map(x => {
            if (x.id === element.infrastructureId) {
              this.listInfrastructures.push({ id: x.id, name: x.name, checked: false })
            }
          });
          // this.listInfrastructures = res.results.map(x => ({ id: x.id, name: x.name, checked: false }));
        });

          for (const item of this.listInfrastructures) {
            this.listDisInfrastructure.push(
              new FormGroup({
                id: new FormControl(0),
                disEducationAndTrainingOrSchoolId: new FormControl(this.dataTransmission),
                infrastructureId: new FormControl(item.id),
                amount: new FormControl(0, Validators.required),
              }),
            );
          }
      }
      if(this.codeInfrastructures.length > 0){
        debugger;
       this.listDisInfrastructure.clear();
       for (const item of res.results) {
         this.listDisInfrastructure.push(
           new FormGroup({
             id: new FormControl(0),
             disEducationAndTrainingOrSchoolId: new FormControl(this.dataTransmission),
             infrastructureId: new FormControl(item.id),
             amount: new FormControl(0, Validators.required),
           }),
         );
       }
     }

      this.listDisInfrastructure.patchValue(value);
    });
  }

  //loại phương tiện học liệu
  getFacilitiesAndEquipment(value) {
    this.caFacilitiesAndEquipmentsService.getSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      this.listFacilitiesAndEquipments = res.results.map(x => ({ id: x.id, name: x.name, checked: false }));
      for (const item of res.results) {
        this.listFacilitiesAndEquipment.push(
          new FormGroup({
            id: new FormControl(0),
            disEducationAndTrainingOrSchoolId: new FormControl(this.dataTransmission),
            facilitiesAndEquipmentId: new FormControl(item.id),
            amountStatus: new FormControl('', Validators.required),
            quantityStatus: new FormControl('', Validators.required),
            name: new FormControl(item.name),
          }),
        );
      }
      this.listFacilitiesAndEquipment.controls.forEach((element) => {
        value.forEach(val => {
          if (element.value.facilitiesAndEquipmentId === val.facilitiesAndEquipmentId) {
            element.get('amountStatus').setValue(val.amountStatus);
            element.get('quantityStatus').setValue(val.quantityStatus);
          }
        });
      });
    });
  }
}
